module.exports = __webpack_public_path__ + "img/french_flag.0f404549.svg";